<template>
    <el-form-item
        class="table-form-item"
        :prop="propUrl"
        :rules="itemRule"
        :ref="uuidItem">
        <template>
              <!-- v-model="isShow" -->
            <el-tooltip
              v-model="isShow"
              :disabled="!isShow"
              :manual="true"
              :offset="7"
              :arrowOffset="-2"
              :disabled1="isDisable"
              effect="dark"
              placement="top-start">
              <div slot="content" style="display: flex;">
                <img src="../assets/img/errorTip.svg" alt="">
                <span style="margin-left: 5px;">{{ tooltipMsg }}</span>
              </div>
              <slot :handler="this"></slot>
            </el-tooltip>
        </template>
    </el-form-item>
</template>
<script>
import { generateUUID } from '~/util/commonUtil.js'
export default {
    name: 'table-form-item',
    props:{
        // 取值路径
        propUrl:{
            type: String,
            default: ''
        },
        // item 校验规则
        itemRule:{
            type: Array,
            default: []
        },
    },
    data(){
        return{
            uuidItem: '',
            itemRef: {},
            isShow: false,
            tooltipMsg: '',
            showFlag: false
        }
    },
    computed:{
      isDisable(){
        if(this.itemRef.validateState === 'error'){
          this.tooltipMsg = this.itemRef.validateMessage
          // setTimeout(() => {
            this.isShow = true;
          // }, 0);
          return {};
        }
        this.tooltipMsg = '';
        this.isShow = false;
        return {}
      }
    },
    created(){
        this.uuidItem = generateUUID();
    },
    mounted(){
      this.$nextTick(()=>{
        this.itemRef = this.$refs[this.uuidItem];
      })
    },
    methods:{
      showTooltip(tooltipMsg){
        this.showFlag = true
        // this.isShow = false;
        // Promise.resolve().then(()=>{
        this.tooltipMsg = tooltipMsg;
        this.isShow = true;
        // })
      },
      hiddenTooltip(){
        // this.isShow = false;
        // Promise.resolve().then(()=>{
        this.tooltipMsg = '';
        this.isShow = false;
        // })
      },
    },
}
</script>
<style lang="less" scoped>
</style>